import { useState, useEffect } from 'react';
import { Box, Grid, Typography, Button, useTheme } from '@mui/material';
import RoomRow from './RoomRow';
import { useSelector } from 'react-redux';
import {
  getPublicParameters,
  getIfCanBookNonRef,
} from '@shared/services/services';

import { sxStyle } from './styles';

const RoomsTable = ({
  rates,
  id_integration,
  check_in,
  id_hotel,
  total_passangers,
  total_nights,
  id_provider,
  data,
  urlToken,
  hotelCode,
  idCity,
  country,
  supplier_code,
}) => {
  const [sortedRooms, setSortedRooms] = useState([]);

  const { data: integrations } = useSelector(store => store.integrations);
  const integration = integrations.find(obj => obj.id == id_integration);

  const [canBuy, setCanBuy] = useState(true);
  const [canBook, setCanBook] = useState(true);
  const [canBookNoRef, setCanBookNoRef] = useState(false);
  const user = useSelector(store => store.userInfo);

  const theme = useTheme();

  // Nuevo estado para el paginado interno
  const [visibleCount, setVisibleCount] = useState(5);

  const pageId = useSelector(store => store.pageConfiguration.id);

  const fetchPublicParameters = async () => {
    const isNational = country?.toUpperCase()?.trim() === 'ARGENTINA';

    const salesNames = {
      true: 'salesHotelsNational',
      false: 'salesHotelsInternational',
    };
    const bookNames = {
      true: 'bookHotelsNational',
      false: 'bookHotelsInternational',
    };
    const bookNoRefNames = {
      true: 'nonRefundableBookHotelsNational',
      false: 'nonRefundableBookHotelsInternational',
    };

    const params = { parameter_types: 5 };

    const sales = salesNames[isNational];
    const booking = bookNames[isNational];
    const bookingNoRef = bookNoRefNames[isNational];

    const response = await getPublicParameters(params);

    setCanBuy(response.find(x => x.name === sales)?.value);
    setCanBook(response.find(x => x.name === booking)?.value);

    let siteCanBookNoRef = response.find(x => x.name === bookingNoRef)?.value;
    if (siteCanBookNoRef) {
      try {
        if (!user?.user?.id) throw new Error('No user logged in');
        const gifCanBookNonRef = await getIfCanBookNonRef(user?.user?.id);
        siteCanBookNoRef = gifCanBookNonRef?.can_book_non_refundables;
      } catch (error) {
        console.error('error', error);
      }
    }
    if (!user?.userToken) siteCanBookNoRef = false;
    setCanBookNoRef(siteCanBookNoRef);
  };

  useEffect(() => {
    setSortedRooms(rates);
    fetchPublicParameters();
  }, [rates]);

  // Funciones para ver más o ver menos
  const handleShowMore = () => {
    setVisibleCount(prev => prev + 5);
  };

  const handleShowLess = () => {
    setVisibleCount(5);
  };

  const roomsToShow = sortedRooms.slice(0, visibleCount);

  return (
    <Grid container justifyContent="center">
      <Box style={{ padding: '8px 24px', width: '100%' }}>
        <Typography sx={sxStyle.sectionTitle}>
          Habitaciones disponibles:
        </Typography>

        <Grid container>
          {roomsToShow.map((room, key) => (
            <Grid item xs={12} key={room.id_product}>
              <RoomRow
                room={room}
                id_integration={id_integration}
                check_in={check_in}
                id_hotel={id_hotel}
                total_passangers={total_passangers}
                total_nights={total_nights}
                id_provider={id_provider}
                last={key === roomsToShow.length - 1}
                data={data}
                index={key}
                urlToken={urlToken}
                hotelCode={hotelCode}
                idCity={idCity}
                canBuy={canBuy}
                canBook={canBook}
                canBookNoRef={canBookNoRef}
                integration={integration}
                supplier_code={supplier_code}
              />
            </Grid>
          ))}
        </Grid>

        {sortedRooms.length > 5 && (
          <Box display="flex" justifyContent="center" marginTop={2} gap={2}>
            {visibleCount < sortedRooms.length && (
              <Button
                variant="outlined"
                onClick={handleShowMore}
                style={{
                  backgroundColor: theme.primary,
                  color: pageId == 1 ? '#000000' : '#fff',
                  fontWeight: '600',
                  width: '100%',
                  maxWidth: '110px',
                }}
              >
                Ver más
              </Button>
            )}
            {visibleCount > 5 && (
              <Button
                variant="outlined"
                onClick={handleShowLess}
                style={{
                  borderColor: theme.tertiary,
                  color: theme.tertiary,
                  fontWeight: '600',
                  width: '100%',
                  maxWidth: '110px',
                }}
              >
                Ver menos
              </Button>
            )}
          </Box>
        )}
      </Box>
    </Grid>
  );
};

export default RoomsTable;
